import { render, staticRenderFns } from "./item_pro_type.vue?vue&type=template&id=70abe148&scoped=true&"
import script from "./item_pro_type.vue?vue&type=script&lang=js&"
export * from "./item_pro_type.vue?vue&type=script&lang=js&"
import style0 from "./item_pro_type.vue?vue&type=style&index=0&id=70abe148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70abe148",
  null
  
)

export default component.exports